var root = require('./_root');

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;



//////////////////
// WEBPACK FOOTER
// ./node_modules/lodash/_coreJsData.js
// module id = 219
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 13 14 15 16 17 18